"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lawscopeNameValueMap = exports.lawscopeNameValue = exports.LawScope = void 0;
var LawScope;
(function (LawScope) {
    LawScope["FR"] = "fr";
    LawScope["EU"] = "eu";
})(LawScope || (exports.LawScope = LawScope = {}));
var lawscopeNameValue = [
    {
        label: 'Droit français',
        value: LawScope.FR,
    },
    {
        label: 'Droit européen',
        value: LawScope.EU,
    },
];
exports.lawscopeNameValue = lawscopeNameValue;
var lawscopeNameValueMap = new Map();
exports.lawscopeNameValueMap = lawscopeNameValueMap;
lawscopeNameValue.forEach(function (_a) {
    var label = _a.label, value = _a.value;
    return lawscopeNameValueMap.set(value, label);
});
lawscopeNameValueMap.set(null, '');
//# sourceMappingURL=lawScope.js.map